
// ============================================================================
// DECOMPOSITION MAP - PART 9
// Bread, Pasta, Canned, Frozen, Alcohol remaining
// ============================================================================

import { DecompositionEntry } from './db-types';

export const breadPastaEtc: DecompositionEntry[] = [
  // ==========================================================================
  // BREAD ITEMS
  // ==========================================================================
  { foodId: "arepa", ingredients: ["corn_meal", "salt", "water"] },
  { foodId: "banana_bread", ingredients: ["flour", "banana", "butter", "egg", "sugar", "baking_soda", "cinnamon", "walnut", "vanilla", "salt"] },
  { foodId: "bao_bun", ingredients: ["flour", "yeast", "sugar", "vegetable_oil", "milk", "baking_powder", "salt"] },
  { foodId: "bread", ingredients: ["flour", "yeast", "salt", "water"] },
  { foodId: "breadstick", ingredients: ["flour", "olive_oil", "yeast", "salt"] },
  { foodId: "bretzel", ingredients: ["flour", "yeast", "butter", "sugar", "salt", "baking_soda"] },
  { foodId: "choux_pastry", ingredients: ["flour", "butter", "egg", "milk", "salt"] },
  { foodId: "cornbread", ingredients: ["corn_meal", "flour", "butter", "egg", "milk", "sugar", "baking_powder", "salt"] },
  { foodId: "crispbread", ingredients: ["rye", "flour", "salt"] },
  { foodId: "crumpet", ingredients: ["flour", "yeast", "milk", "baking_soda", "sugar", "salt"] },
  { foodId: "danish_pastry", ingredients: ["flour", "butter", "egg", "yeast", "milk", "sugar", "cream_cheese", "fruit", "salt"] },
  { foodId: "dosa", ingredients: ["rice", "lentil", "salt"] },
  { foodId: "flatbread", ingredients: ["flour", "olive_oil", "salt"] },
  { foodId: "flour_tortilla", ingredients: ["flour", "lard", "salt", "water"] },
  { foodId: "idli", ingredients: ["rice", "lentil", "salt"] },
  { foodId: "matzo", ingredients: ["flour", "salt", "water"] },
  { foodId: "melba_toast", ingredients: ["bread"] },
  { foodId: "multigrain_bread", ingredients: ["flour", "wheat", "oat", "flaxseed", "yeast", "honey", "salt"] },
  { foodId: "phyllo", ingredients: ["flour", "olive_oil", "vinegar", "salt"] },
  { foodId: "pie_crust", ingredients: ["flour", "butter", "salt", "water"] },
  { foodId: "pizza_dough", ingredients: ["flour", "yeast", "olive_oil", "sugar", "salt"] },
  { foodId: "puff_pastry", ingredients: ["flour", "butter", "salt", "water"] },
  { foodId: "puri", ingredients: ["flour", "vegetable_oil", "salt"] },
  { foodId: "rye_bread", ingredients: ["rye", "flour", "yeast", "caraway", "salt"] },
  { foodId: "shortcrust_pastry", ingredients: ["flour", "butter", "egg", "salt"] },
  { foodId: "toast", ingredients: ["bread", "butter"] },
  { foodId: "uttapam", ingredients: ["rice", "lentil", "onion", "tomato", "chili_pepper", "cilantro", "salt"] },
  { foodId: "white_bread", ingredients: ["flour", "yeast", "sugar", "butter", "milk", "salt"] },
  { foodId: "whole_wheat_bread", ingredients: ["flour", "wheat", "yeast", "honey", "butter", "salt"] },
  { foodId: "wrap", ingredients: ["flour", "vegetable_oil", "salt"] },
  { foodId: "zucchini_bread", ingredients: ["flour", "zucchini", "egg", "sugar", "vegetable_oil", "cinnamon", "baking_soda", "walnut", "vanilla", "salt"] },

  // ==========================================================================
  // MORE PASTA
  // ==========================================================================
  { foodId: "acini_di_pepe", ingredients: ["flour", "egg", "salt"] },
  { foodId: "agnolotti", ingredients: ["flour", "egg", "beef", "spinach", "parmesan", "nutmeg", "salt"] },
  { foodId: "angel_hair", ingredients: ["flour", "egg", "salt"] },
  { foodId: "bucatini", ingredients: ["flour", "egg", "salt"] },
  { foodId: "campanelle", ingredients: ["flour", "egg", "salt"] },
  { foodId: "cavatappi", ingredients: ["flour", "egg", "salt"] },
  { foodId: "chow_mein_noodles", ingredients: ["flour", "egg", "vegetable_oil", "salt"] },
  { foodId: "conchiglie", ingredients: ["flour", "egg", "salt"] },
  { foodId: "ditalini", ingredients: ["flour", "egg", "salt"] },
  { foodId: "dumpling_wrappers", ingredients: ["flour", "salt", "water"] },
  { foodId: "elbow_macaroni", ingredients: ["flour", "egg", "salt"] },
  { foodId: "fresh_pasta", ingredients: ["flour", "egg", "olive_oil", "salt"] },
  { foodId: "gemelli", ingredients: ["flour", "egg", "salt"] },
  { foodId: "gluten_free_pasta", ingredients: ["rice", "corn_meal", "quinoa", "salt"] },
  { foodId: "gnocchetti", ingredients: ["flour", "egg", "salt"] },
  { foodId: "instant_noodles", ingredients: ["flour", "vegetable_oil", "salt"] },
  { foodId: "lasagna", ingredients: ["flour", "egg", "salt"] },
  { foodId: "lo_mein", ingredients: ["flour", "egg", "salt"] },
  { foodId: "manicotti", ingredients: ["flour", "egg", "salt"] },
  { foodId: "pad_thai_noodles", ingredients: ["rice", "salt"] },
  { foodId: "pasta", ingredients: ["flour", "egg", "salt"] },
  { foodId: "perciatelli", ingredients: ["flour", "egg", "salt"] },
  { foodId: "pho_noodles", ingredients: ["rice", "salt"] },
  { foodId: "rice_vermicelli", ingredients: ["rice", "salt"] },
  { foodId: "rotini", ingredients: ["flour", "egg", "salt"] },
  { foodId: "shirataki", ingredients: ["konjac", "water"] },
  { foodId: "soba", ingredients: ["buckwheat", "flour", "salt"] },
  { foodId: "spaghettini", ingredients: ["flour", "egg", "salt"] },
  { foodId: "spring_roll_wrappers", ingredients: ["rice", "salt", "water"] },
  { foodId: "stelline", ingredients: ["flour", "egg", "salt"] },
  { foodId: "tagliolini", ingredients: ["flour", "egg", "salt"] },
  { foodId: "vermicelli", ingredients: ["flour", "egg", "salt"] },
  { foodId: "whole_wheat_pasta", ingredients: ["flour", "wheat", "egg", "salt"] },
  { foodId: "wonton_wrappers", ingredients: ["flour", "egg", "salt"] },
  { foodId: "ziti", ingredients: ["flour", "egg", "salt"] },

  // ==========================================================================
  // CANNED ITEMS
  // ==========================================================================
  { foodId: "black_olives", ingredients: ["olive", "salt"] },
  { foodId: "canned_artichokes", ingredients: ["artichoke", "olive_oil", "salt"] },
  { foodId: "coconut_milk_canned", ingredients: ["coconut"] },
  { foodId: "canned_coconut_milk", ingredients: ["coconut"] },
  { foodId: "canned_fruit", ingredients: ["peach", "pear", "pineapple", "sugar"] },
  { foodId: "canned_green_beans", ingredients: ["green_bean", "salt"] },
  { foodId: "canned_mushrooms", ingredients: ["mushroom", "salt"] },
  { foodId: "canned_olives", ingredients: ["olive", "salt"] },
  { foodId: "canned_peaches", ingredients: ["peach", "sugar"] },
  { foodId: "canned_pineapple", ingredients: ["pineapple", "sugar"] },
  { foodId: "canned_pumpkin", ingredients: ["pumpkin"] },
  { foodId: "canned_tuna_chunk", ingredients: ["tuna", "olive_oil", "salt"] },
  { foodId: "crushed_tomatoes", ingredients: ["tomato", "salt"] },
  { foodId: "diced_tomatoes", ingredients: ["tomato", "salt"] },
  { foodId: "evaporated_milk_canned", ingredients: ["milk"] },
  { foodId: "green_olives", ingredients: ["olive", "salt"] },
  { foodId: "jam", ingredients: ["strawberry", "raspberry", "sugar", "pectin", "lemon"] },
  { foodId: "jelly", ingredients: ["grape", "sugar", "pectin"] },
  { foodId: "kalamata_olives", ingredients: ["olive", "salt", "vinegar"] },
  { foodId: "marmalade", ingredients: ["orange", "lemon", "sugar", "pectin"] },
  { foodId: "pickled_jalapenos", ingredients: ["jalapeno", "vinegar", "salt"] },
  { foodId: "preserves", ingredients: ["strawberry", "sugar", "pectin", "lemon"] },
  { foodId: "condensed_milk_canned", ingredients: ["milk", "sugar"] },
  { foodId: "tomato_puree", ingredients: ["tomato", "salt"] },

  // ==========================================================================
  // FROZEN ITEMS
  // ==========================================================================
  { foodId: "frozen_banana", ingredients: ["banana"] },
  { foodId: "frozen_blueberries", ingredients: ["blueberry"] },
  { foodId: "frozen_bread", ingredients: ["flour", "yeast", "salt"] },
  { foodId: "frozen_broccoli", ingredients: ["broccoli"] },
  { foodId: "frozen_burrito", ingredients: ["tortilla", "black_bean", "beef", "rice", "cheddar", "tomato", "salt"] },
  { foodId: "frozen_burritos", ingredients: ["tortilla", "black_bean", "beef", "rice", "cheddar", "tomato", "salt"] },
  { foodId: "frozen_chicken", ingredients: ["chicken"] },
  { foodId: "frozen_corn", ingredients: ["corn"] },
  { foodId: "frozen_dinner", ingredients: ["chicken", "rice", "vegetable", "sauce", "salt"] },
  { foodId: "frozen_dumplings", ingredients: ["flour", "pork", "cabbage", "scallion", "ginger", "soy_sauce", "sesame_oil", "salt"] },
  { foodId: "frozen_fish", ingredients: ["cod", "salmon"] },
  { foodId: "frozen_mixed_veg", ingredients: ["pea", "carrot", "corn", "green_bean"] },
  { foodId: "frozen_pancakes", ingredients: ["flour", "egg", "milk", "butter", "sugar", "baking_powder", "salt"] },
  { foodId: "frozen_peas", ingredients: ["pea"] },
  { foodId: "frozen_pie_crust", ingredients: ["flour", "butter", "salt"] },
  { foodId: "frozen_puff_pastry", ingredients: ["flour", "butter", "salt"] },
  { foodId: "frozen_shrimp", ingredients: ["shrimp"] },
  { foodId: "frozen_spinach", ingredients: ["spinach"] },
  { foodId: "frozen_strawberries", ingredients: ["strawberry"] },
  { foodId: "frozen_waffles", ingredients: ["flour", "egg", "milk", "butter", "sugar", "baking_powder", "salt"] },

  // ==========================================================================
  // MORE ALCOHOL
  // ==========================================================================
  { foodId: "aperol", ingredients: ["bitter_orange", "rhubarb", "gentian", "cinchona"] },
  { foodId: "akvavit", ingredients: ["potato", "grain", "caraway", "dill", "fennel"] },
  { foodId: "campari", ingredients: ["bitter_orange", "rhubarb", "ginseng"] },
  { foodId: "craft_beer", ingredients: ["barley", "hop", "yeast", "water"] },
  { foodId: "dark_rum", ingredients: ["sugar", "molasses"] },
  { foodId: "dessert_wine", ingredients: ["grape"] },
  { foodId: "gluhwein", ingredients: ["wine", "sugar", "cinnamon", "clove", "orange", "star_anise"] },
  { foodId: "hard_seltzer", ingredients: ["water", "sugar"] },
  { foodId: "ipa", ingredients: ["barley", "hop", "yeast", "water"] },
  { foodId: "irish_whiskey", ingredients: ["barley", "corn"] },
  { foodId: "kir", ingredients: ["wine", "cassis"] },
  { foodId: "liqueur", ingredients: ["sugar", "fruit", "herb"] },
  { foodId: "non_alcoholic_beer", ingredients: ["barley", "hop", "yeast", "water"] },
  { foodId: "pastis", ingredients: ["anise", "licorice", "sugar"] },
  { foodId: "pilsner", ingredients: ["barley", "hop", "yeast", "water"] },
  { foodId: "porter", ingredients: ["barley", "hop", "yeast", "water"] },
  { foodId: "sambuca", ingredients: ["anise", "elderflower", "sugar"] },
  { foodId: "sangria", ingredients: ["wine", "orange", "lemon", "apple", "sugar", "brandy"] },
  { foodId: "soju", ingredients: ["rice", "wheat", "barley"] },
  { foodId: "sparkling_wine", ingredients: ["grape"] },
  { foodId: "tinto_de_verano", ingredients: ["wine", "lemon", "sugar"] },
  { foodId: "tinto_verano", ingredients: ["wine", "lemon", "sugar"] },
  { foodId: "wheat_beer", ingredients: ["wheat", "barley", "hop", "yeast"] },
  { foodId: "white_rum", ingredients: ["sugar"] },
  { foodId: "wine", ingredients: ["grape"] },

  // ==========================================================================
  // BAKERY INGREDIENTS
  // ==========================================================================
  { foodId: "active_dry_yeast", ingredients: ["yeast"] },
  { foodId: "agar_agar", ingredients: ["agar"] },
  { foodId: "all_purpose_flour", ingredients: ["wheat"] },
  { foodId: "arrowroot", ingredients: ["arrowroot"] },
  { foodId: "baking_chocolate", ingredients: ["cocoa", "sugar"] },
  { foodId: "baking_powder", ingredients: ["baking_soda", "cream_of_tartar", "cornstarch"] },
  { foodId: "baking_soda", ingredients: ["sodium_bicarbonate"] },
  { foodId: "bread_flour", ingredients: ["wheat"] },
  { foodId: "cake_flour", ingredients: ["wheat"] },
  { foodId: "chocolate_ganache", ingredients: ["chocolate", "cream"] },
  { foodId: "cocoa_powder", ingredients: ["cocoa"] },
  { foodId: "coconut_flour", ingredients: ["coconut"] },
  { foodId: "cornstarch", ingredients: ["corn"] },
  { foodId: "danish_wienerbrød", ingredients: ["flour", "butter", "egg", "yeast", "milk", "sugar", "cardamom", "salt"] },
  { foodId: "flour", ingredients: ["wheat"] },
  { foodId: "fondant", ingredients: ["sugar", "water", "corn_syrup"] },
  { foodId: "fresh_yeast", ingredients: ["yeast"] },
  { foodId: "frosting", ingredients: ["butter", "sugar", "milk", "vanilla"] },
  { foodId: "gelatin", ingredients: ["gelatin"] },
  { foodId: "gluten_free_flour", ingredients: ["rice", "tapioca", "potato"] },
  { foodId: "instant_yeast", ingredients: ["yeast"] },
];
